export const searchTypeMap = {
  INTERNAL_REFERENCE_NUMBER: 'Internal Ref #',
  INQUIRY_NUMBER: 'Inquiry #',
  BOOKING_NUMBER: 'Booking #',
};

// TODO: find an alternative to remove the default data from here
export const CreateEnquiryFormConfig = {
  FCL: {
    containerDetailsVisible: true,
    stuffingLocation: true,
    containerWiseWeight: true,
    preferredShippingLine: true,
    packagingDetailsVisible: true,
    packageDimensions:true,
    allowedServices: 'allowedInquiryServicesFclLcl',
    defaultStateData: {
      originPorts: undefined,
      originPortsPre: undefined,
      destinationPorts: undefined,
      originPort: undefined,
      originPortName: undefined,
      destinationPort: undefined,
      destinationPortName: undefined,
      destinationCountry: undefined,
      destinationCountryName: undefined,
      originCountry: undefined,
      originPortCountry: undefined,
      destinationPortCountry: undefined,
      originServices: ['Port Service'],
      destinationServices: [],
    },
  },
  LCL: {
    stackableVisible: true,
    packagingDetailsVisible: true,
    preferredShippingLine: true,
    packageType: 'lclPackageTypes',
    allowedServices: 'allowedInquiryServicesFclLcl',
    defaultStateData: {
      originPorts: undefined,
      originPortsPre: undefined,
      destinationPorts: undefined,
      originPort: undefined,
      originPortName: undefined,
      destinationPort: undefined,
      destinationPortName: undefined,
      destinationCountry: undefined,
      destinationCountryName: undefined,
      originCountry: undefined,
      originPortCountry: undefined,
      destinationPortCountry: undefined,
      originServices: ['Port Service'],
      destinationServices: [],
    },
  },
  AIRCARGO: {
    isAir: true,
    stackableVisible: true,
    packagingDetailsVisible: true,
    stuffingLocation: true,
    preferredAirCarrier: true,
    packageType: 'airCargoPackageTypes',
    dimensionsMandatory: true,
    defaultPackageType: 'BOX',
    allowedServices: 'allowedInquiryServicesAIRCARGO',
    defaultStateData: {
      originPorts: undefined,
      originPortsPre: undefined,
      destinationPorts: undefined,
      originPort: undefined,
      originPortName: undefined,
      destinationPort: undefined,
      destinationPortName: undefined,
      destinationCountry: undefined,
      destinationCountryName: undefined,
      originCountry: undefined,
      originPortCountry: undefined,
      destinationPortCountry: undefined,
      originServices: [],
      destinationServices: [],
    },
  },
  DOMESTIC: {
    packagingDetailsVisible: false,
    packageType: 'domesticPackageTypes',
    stackableVisible: false,
    dimensionsMandatory: false,
  },
  RPTL: {
    stackableVisible: true,
    packagingDetailsVisible: true,
    packageType: 'lclPackageTypes',
    dimensionsMandatory: false,
  },
};

export enum ORGANISATION_SIZE {
  SME = 'SME',
  ENTERPRISE = 'ENTERPRISE',
};

export const EXCLUDED_WEIGHT_UNITS = ['cases'];

// const INQUIRY_AUTO_REFRESH_INTERVAL = 45 * 1000;
export const INQUIRY_AUTO_REFRESH_INTERVAL_FF = 45 * 1000;
export const INQUIRY_AUTO_REFRESH_INTERVAL_SHIPPER = 60 * 1000;

export type Doc = {
  file: Record<string, never> | {
    ext: string;
    name: string;
    s3Link: string;
  };
  type: string;
  uploading: boolean;
};

export type Docs = Record<string, Doc>;

export const disableAddOfflineBidForDomestic = true;

export const MAX_DOMESTIC_STOP_LOCATIONS = 10;
export const DOMESTION_STOP_LOCATION_MAX_LENGTH = 50;

export enum PortKeys {
  LOADING_PORT = 'loadingPort',
  ORIGIN_PORTS = 'originPorts',
  DESTINATION_PORT = 'destinationPort',
  DESTINATION_PORTS = 'destinationPorts',
}

export const DISPATCH_MODE_OPTIONS = [
  { label: 'LOOSE', value: 'LOOSE' },
  { label: 'PALLET', value: 'PALLET' },
];

export const DISPATCH_MODE_LABELS: { [key: string]: string } = {
  LOOSE: 'LOOSE',
  PALLET: 'PALLET',
};
